import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Type } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslocoDirective } from '@jsverse/transloco';
import { FieldType, FieldTypeConfig, FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';
import { ToggleSwitch } from '@openng/optimus-ui/toggleswitch';
import { FieldWrapperProps } from '../../wrappers/field-wrapper/field-wrapper.component';

interface ToggleProps extends FieldWrapperProps {}

export interface ToggleFieldConfig extends FormlyFieldConfig<ToggleProps> {
  type?: 'toggle' | Type<ToggleTypeComponent>;
}

@Component({
  selector: 'lib-toggle-type',
  templateUrl: './toggle-type.component.html',
  styleUrl: './toggle-type.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslocoDirective, ToggleSwitch, NgClass, ReactiveFormsModule, FormlyModule]
})
export class ToggleTypeComponent extends FieldType<FieldTypeConfig<ToggleProps>> {}
